import getClusterResolutions from "../../../utils/get-cluster-resolutions";
import getCurrentResolution from "../../../utils/get-current-resolution";
import processValueLevels from "./process-value-levels";

/**
 * Process storage properties (without last-level values)
 * @param {MainClassProps} main
 */
const processStorageProperties = (main) => {
  const layers = /** @type {StoragePropertiesProps } */ (
    main.storage.get("properties")
  );

  for (const layer of layers) {
    /** Layer number */
    let number = 0;

    for (const property of layer) {
      property.set("resolutions", new Map());

      const original = /** @type {String} */ (property.get("original"));

      const resolutions = getClusterResolutions(original, 1);

      const flat = /** @type {StorageItemFlatProps} */ (property.get("flat"));
      const pure = /** @type {Map<String, any>} */ (property.get("pure"));
      const data = /** @type {StorageItemDataProps} */ (property.get("data"));

      const info = new Map([
        ["parent", property.get("parent")],
        ["fn", property.get("fn")],
        ["path", property.get("path")],
        ["is-none-initial", property.get("is-none-initial")],
      ]);

      if (!original) {
        continue;
      }

      /** Resolutions map */
      const map = /** @type {ResolutionProps} */ (property.get("resolutions"));

      /** Get current resolution */
      const current = getCurrentResolution(resolutions);

      /** Get the value of currently used resolutions */
      const value = /** @type {String} */ (resolutions.get(current));

      // TODO: check if the number of current properties is different that initial
      // for example "box-shadow"
      // console.log(
      //   value,
      //   value.split(/[▁▂]/).length - 1,
      //   data.get("trigger")?.get("type")
      // );

      /** Process string value */
      const processed = processValueLevels(
        value,
        main,
        flat,
        pure,
        data,
        info,
        number
      );

      /** Set the processed values to tje "current" resolution */
      map.set("current", processed);

      ++number;
    }
  }
};

export default processStorageProperties;
